/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newsletter_Unsubscribe_CrumbInputs */

const en_newsletter_unsubscribe_crumb = /** @type {(inputs: Newsletter_Unsubscribe_CrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unsubscribe`)
};

/**
* | output |
* | --- |
* | "Unsubscribe" |
*
* @param {Newsletter_Unsubscribe_CrumbInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const newsletter_unsubscribe_crumb = /** @type {((inputs?: Newsletter_Unsubscribe_CrumbInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newsletter_Unsubscribe_CrumbInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_newsletter_unsubscribe_crumb(inputs)
});